<template>
    <div class="products-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
               
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Promotion Details
                        </div>
                    </div>      

                    <div class="col-md-4">
                       <div class="top-navbar-right">
                            <button class="btn btn-ecdc" @click="$router.push({ name: 'productsPromotionCreate' });">Create Promotion</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="row">
                <transition name="fade" mode="out-in">
                    <div v-show="toggleFilter" id="side-filter-col" class="col-lg-3">
                        <div class="side-filter">

                            <div class="title">
                                Filter
                            </div> 

                            <div class="form-group">
                                <div class="label">Brands</div>

                                <app-multi-select 
                                    :options="brandOptions.map(brandOption => brandOption.id)"
                                    :custom-label="opt => brandOptions.find(x => x.id == opt).name"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true" 
                                    :preselect-first="false"
                                    :placeholder="'-- All Brand --'"
                                    v-model="filter.brand">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                </app-multi-select>

                                <div class="selected-label" v-if="filter.brand.length > 0">
                                    FILTER:
                                    <div v-for="brand in filter.brand" :key="brand">{{ brandOptions.find(x => x.id == brand).name}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="label">Categories</div>
                                <app-multi-select 
                                    :options="catOptions.map(catOption => catOption.id)"  
                                    :custom-label="opt => catOptions.find(x => x.id == opt).name"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true" 
                                    :preselect-first="false"
                                    :placeholder="'-- All Category --'"
                                    v-model="filter.category">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                                </app-multi-select>

                                <div class="selected-label" v-if="filter.category.length > 0">
                                    FILTER:
                                    <div v-for="category in filter.category" :key="category">{{ catOptions.find(x => x.id == category).name}}</div>
                                </div>
                            </div>

                            <div class="filter-action">
                                <button type="button" class="btn btn-ecdc btn-block" @click="setFilter()">Apply</button>
                                <button type="button" class="btn btn-link btn-block text-light" @click="clearFilter()">Clear Filter</button>
                            </div>
                        </div>
                    </div>
                </transition>

                <div id="table-content-col" :class="toggleFilter ? 'col-lg-9 filter-expanded' : 'col-lg'">

                    <div class="table-options row justify-content-between align-items-center">
                        <div class="col-lg">
                            <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc btn-filter">Filter</button>

                            <!-- <div class="table-search form-inline d-inline-block ml-4">
                                <input type="text" class="form-control" placeholder="Search by keyword">                         <button type="button" class="btn btn-ecdc btn-circle">
                                    <app-icon-search></app-icon-search>
                                </button>       
                            </div> -->
                        </div>
                        <div class="col-lg">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateTop"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped result-table">
                            <thead>
                                <tr>
                                    <th>Promotion Name</th>
                                    <th>Promotion Price</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Created On</th>
                                    <th>Last Edited</th>
                                    <th>Status</th>
                                    <th class="text-center">ACTION</th>
                                </tr>
                            </thead>

                            <tbody v-if="!isLoading">
                                <tr v-for="product in productsData.data" v-bind:key="product.id">
                                    <td>{{ product.name }}</td>
                                    <td>{{ product.price }}</td>
                                    <td>{{ product.start_date }}</td>
                                    <td>{{ product.end_date }}</td>
                                    <td>{{ product.created_at }}</td>
                                    <td>{{ product.updated_at }}</td>
                                    <td v-if="product.valid ==1 ">Ongoing</td>
                                    <td v-if="product.valid ==0 ">Ended</td>
                                    <td class="text-center" @click="edit(product.id)">
                                        <button class="btn btn-link btn-icon icon-right">
                                            Edit 
                                            <img class="icon" src="../assets/img/icon-edit.png" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-between table-options">
                        <div class="col-lg">
                            <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            per page
                        </div>
                        <div class="col-lg text-center">
                            {{ showingResults }}
                        </div>
                        <div class="col-lg">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateBottom"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getPromotions } from '../api'
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'
// import IconSearch from '../svg/Search.vue'
import Multiselect from 'vue-multiselect'

export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate,
        // appIconSearch: IconSearch,
        appMultiSelect: Multiselect
    },
    data() {
        return {
            filter: {
                brand: [],
                category: []
            },
            brandOptions: [
                { name: 'Dunhill', id: 1 },
                { name: 'Lucky Strike', id: 2 },
                { name: 'Others', id: 0 }
            ],
            catOptions: [
                { name: 'Bentoel', id: 1 },
                { name: 'Rokok Putih', id: 2 },
                { name: 'Mild', id: 3 },
                { name: 'SKM', id: 4 },
                { name: 'SKT', id: 5 },
                { name: 'Vape', id: 999 }
            ],
            productsData: "",
            isLoading: true,
            totalPage: 0,
            pageLimit: 15,
            showingResults: "",
            toggleFilter: true
        }
    },
    async mounted() {

        await this.getPromotions(1);
        this.isLoading = false;
    },
    methods: {
        async pagination(pageNum) {

            this.isLoading = true;  
            
            if(pageNum != 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else 
                pageNum = this.$refs.paginateBottom.selected;

            await this.getPromotions(pageNum);

            this.isLoading = false;
        },
        async getPromotions(pageNum) {

            try {
                
                const result = await getPromotions(this.filter, pageNum, this.pageLimit);    
                this.productsData = result.data.data;
                this.totalPage = this.productsData.total / this.pageLimit;

                if(this.totalPage % 1 != 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                var startPage = 1;
                
                if(pageNum != 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                var endPage = pageNum * this.pageLimit;

                if(endPage >= this.productsData.total)
                    endPage = this.productsData.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + this.productsData.total + " results";
            }
            catch(err) {

                alert(err.response.data.message);
            }
        },
        clearFilter() {
            
            this.filter.brand = [];
            this.filter.category = [];
        },
        async setFilter() {

            this.isLoading = true;
            await this.getPromotions(1);
            this.isLoading = false;
        },
        edit(id) {
            this.$router.push({ name: "productsPromotionEdit" , params: { 'id': id }}) ;
        }
    }
}
</script>